import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

import colors from 'vuetify/es5/util/colors'
import es from 'vuetify/lib/locale/es'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    dark: true,
    options: {
      customProperties: true
    },
    themes: {
      dark: {
        primary: '#e9ca7c',
        secondary: '#f5e7c5',
        accent: colors.grey.darken3,
        info: colors.teal.lighten1,
        warning: colors.amber.base,
        error: colors.deepOrange.accent4,
        success: colors.green.accent3
      }
    }
  },
  lang: {
    locales: {es},
    current: 'es'
  }
})
